// Bảng 2 chiều giữa enum của REST và giá trị FE đang dùng (option của form, key i18n, ReviewComplain/constant.js).
// Không cắt tiền tố: COMPLAIN_REASON_LOW_QUANTITY ứng với LOW_QUALITY, khác chữ.
const BE_REASON_TO_UI = {
  COMPLAIN_REASON_LOW_QUANTITY: 'LOW_QUALITY',
  COMPLAIN_REASON_WRONG_ATTRIBUTE: 'WRONG_ATTRIBUTE',
  COMPLAIN_REASON_BROKEN: 'BROKEN',
  COMPLAIN_REASON_FAKE: 'FAKE',
  COMPLAIN_REASON_OUT_DATE: 'OUT_DATE',
  COMPLAIN_REASON_ERROR: 'ERROR',
  COMPLAIN_REASON_SECOND_HAND: 'SECOND_HAND',
  COMPLAIN_REASON_DELAY_DELIVER: 'DELAY_DELIVER',
  COMPLAIN_REASON_INSUFFICIENT: 'INSUFFICIENT',
  COMPLAIN_REASON_WARRANTY_REQUIRED: 'WARRANTY_REQUIRED',
};

const BE_DEMAND_TO_UI = {
  COMPLAIN_DEMAND_SWAP: 'SWAP',
  COMPLAIN_DEMAND_REFUND_A_PART: 'REFUND_A_PART',
  COMPLAIN_DEMAND_BACK_UP_AND_REFUND: 'BACK_UP_AND_REFUND',
  COMPLAIN_DEMAND_WARRANTY: 'WARRANTY',
};

const BE_STATUS_TO_UI = {
  COMPLAIN_STATUS_CREATE: 'CREATE',
  COMPLAIN_STATUS_RECEIVING: 'RECEIVING',
  COMPLAIN_STATUS_PROCESSING: 'PROCESSING',
  COMPLAIN_STATUS_COMPLETED: 'COMPLETED',
};

// Giá trị bên phải là tên bước trong i18n `orderComplain.evenstComplain.*`.
const BE_EVENT_TO_STEP = {
  COMPLAIN_EVENT_CREATE: 'send',
  COMPLAIN_EVENT_RECEIVE: 'receive',
  COMPLAIN_EVENT_PROCESS: 'processing',
  COMPLAIN_EVENT_COMPLETE: 'completed',
};

const invert = (map) => Object.fromEntries(Object.entries(map).map(([beValue, uiValue]) => [uiValue, beValue]));
const UI_REASON_TO_BE = invert(BE_REASON_TO_UI);
const UI_DEMAND_TO_BE = invert(BE_DEMAND_TO_UI);

// Giá trị lạ giữ nguyên chuỗi gốc, không đổi thành rỗng.
const lookup = (map) => (value) => map[value] ?? value;

export const fromBeReason = lookup(BE_REASON_TO_UI);
export const fromBeDemand = lookup(BE_DEMAND_TO_UI);
export const fromBeStatus = lookup(BE_STATUS_TO_UI);
export const fromBeEvent = lookup(BE_EVENT_TO_STEP);
export const toBeReason = lookup(UI_REASON_TO_BE);
export const toBeDemand = lookup(UI_DEMAND_TO_BE);
